var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0417 46.7083C33.0417 48.4292 33.3721 50.0763 33.9313 51.625H12.7083C11.3601 51.625 10.0672 51.107 9.11387 50.1849C8.16056 49.2629 7.625 48.0123 7.625 46.7083V12.2917C7.625 9.5875 9.9125 7.375 12.7083 7.375H48.2917C49.6399 7.375 50.9328 7.893 51.8861 8.81506C52.8394 9.73711 53.375 10.9877 53.375 12.2917V32.8188C51.7738 32.2779 50.0708 31.9583 48.2917 31.9583V12.2917H12.7083V46.7083H33.0417ZM35.4817 30.2129L28.4921 38.9154L23.5104 33.1138L16.5208 41.7917H33.9313C34.9479 39.0383 36.7779 36.6538 39.1417 34.9329L35.4817 30.2129ZM50.8333 44.25V36.875H45.75V44.25H38.125V49.1667H45.75V56.5417H50.8333V49.1667H58.4583V44.25H50.8333Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlus);
export default __webpack_public_path__ + "static/media/imagePlus.40aa8b59.svg";
export { ForwardRef as ReactComponent };